<script lang="ts">
	import IconLottie from '$lib/elements/IconLottie.svelte';
	import { unreadNotifications } from '@app/stores/notifications';

	let ref: HTMLElement;
</script>

<div
	class="flex space-x-2 border border-grey-light rounded-lg p-1 cursor-pointer {$unreadNotifications >
	0
		? ''
		: 'text-grey'}"
	on:click
	role="button"
	bind:this={ref}
>
	<div class="relative min-w-max">
		<IconLottie
			name="bell"
			parentRef={ref}
			animationOnHover={false}
			animationInterval={$unreadNotifications > 0 ? 5000 : undefined}
		/>
	</div>
	<div
		class="flex items-center {$unreadNotifications > 0
			? 'bg-primary-light text-primary'
			: 'bg-grey-lighter text-grey-dark'} px-2 font-bold rounded-lg"
	>
		{$unreadNotifications}
	</div>
</div>
